var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.27 11.59-5.9-2.62C2.87 8.3 2.65 7.4 2.65 6.91s.22-1.39 1.72-2.06l5.9-2.62c.87-.39 2.18-.39 3.05 0l5.91 2.62c1.49.66 1.72 1.57 1.72 2.06s-.22 1.39-1.72 2.06l-5.91 2.62c-.44.2-.98.29-1.53.29-.54 0-1.09-.1-1.52-.29zm.61-7.99-5.9 2.62c-.61.28-.83.56-.83.69 0 .13.22.42.82.69l5.9 2.62c.48.21 1.35.21 1.83 0l5.91-2.62c.61-.27.83-.56.83-.69 0-.13-.22-.42-.83-.69l-5.9-2.62c-.24-.1-.58-.16-.92-.16-.34 0-.67.05-.91.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.88 16.85-6.79-3.02c-1.03-.45-1.84-1.7-1.84-2.83 0-.41.34-.75.75-.75s.75.34.75.75c0 .55.45 1.24.95 1.47l6.79 3.02c.32.14.69.14 1.02 0l6.79-3.02c.5-.22.95-.92.95-1.47 0-.41.34-.75.75-.75s.75.34.75.75c0 1.13-.81 2.38-1.84 2.84l-6.79 3.02c-.36.15-.74.23-1.12.23-.38 0-.76-.08-1.12-.24z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.88 21.85-6.79-3.02a3.106 3.106 0 0 1-1.84-2.84c0-.41.34-.75.75-.75s.75.35.75.76c0 .63.37 1.21.95 1.47l6.79 3.02c.32.14.69.14 1.02 0l6.79-3.02c.58-.26.95-.83.95-1.47 0-.41.34-.75.75-.75s.75.34.75.75c0 1.23-.72 2.34-1.84 2.84l-6.79 3.02c-.36.15-.74.23-1.12.23-.38 0-.76-.08-1.12-.24z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLayer);
export default __webpack_public_path__ + "static/media/vuesax-outline-layer.c3e22221a0685887d59af82968d6527c.svg";
export { ForwardRef as ReactComponent };